import * as ExcelJS from 'exceljs/dist/exceljs.min.js'

export class TransactionReport {
  excelData = []
  sheetTemplate = [{key: 'serialNumber', header: 'Serial number', width: 20}]
  constructor(exportData: any) {
    this.parseData(exportData)
  }

  parseData(data: any) {
    // not much parsing right now
    // this.excelData = data;
    this.excelData = data.map((item: any) => this.flattenObject(item))
  }
  generateExcel() {
    if (this.excelData.length > 0) {
      this.generate()
    } else {
      return
    }
  }
  capitalizeFirstLetter(string) {
    if (typeof string !== 'string' || string.length === 0) {
      return ''
    }
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  handleRowExample(columns, key, value) {
    const columnTemplate = this.sheetTemplate.find((e) => e.key === key)

    if (columnTemplate) {
      columns.push(columnTemplate)
    } else {
      // create fallback
      columns.push({
        key: key,
        header: this.capitalizeFirstLetter(key),
        width: 20,
      })
    }
  }

  flattenObject(obj: any, parentKey: string = '', res: any = {}): any {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        let newKey = parentKey ? `${parentKey}_${key}` : key

        if (Array.isArray(obj[key])) {
          obj[key].forEach((element: any, index: number) => {
            if (typeof element === 'object' && element !== null) {
              this.flattenObject(element, `${newKey}${index}`, res)
            } else {
              res[`${newKey}${index}`] = element
            }
          })
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          this.flattenObject(obj[key], newKey, res)
        } else {
          res[newKey] = obj[key]
        }
      }
    }
    return res
  }

  generate(): Promise<Blob> {
    let workbook = new ExcelJS.Workbook()
    workbook.created = new Date()
    workbook.creator = 'Payter B.V.'

    const columns = []

    const sheet = workbook.addWorksheet('terminals')
    const exampleRow = this.excelData[0] // base the excel on the first row - all rows should be the same (???)
    Object.entries(exampleRow).forEach(([key, value]) => {
      this.handleRowExample(columns, key, value)
    })

    sheet.columns = columns

    sheet.addRows(
      this.excelData.map((record) => {
        return record
      }),
    )

    return workbook.xlsx
      .writeBuffer()
      .then((data) => new Blob([data], {type: 'application/octet-stream'}))
  }
}
